import React from 'react';

interface Props {
    title: string;
    onClick: () => void;
}

const ShowFiltersButton = (props: Props) => {
    return (
        <>
            <button type="button" className="btn btn-block btn-sm btn-default font-4" onClick={props.onClick}>
                <span className="fa fa-sliders display-inline-block mar-r-3 align-middle"></span> {props.title}
            </button>
        </>
    );
};

export default ShowFiltersButton;
